export const TYPE_WALLET_WELFARE = "wallet_welfare";
export const TYPE_WALLET_NEGOZIO = "wallet_negozio";
export const TYPE_WALLET_GRUPPO_NEGOZI = "wallet_gruppo_negozi";
export const TYPE_WALLET_MOD_SERVIZI = "wallet_mod_servizi";
export const TYPE_WALLET_MOD_GRUPPI = "wallet_mod_gruppi";
export const TYPE_WALLET_MOD_FOOD = "wallet_mod_food";
export const TYPE_WALLET_MOD_ECOMMERCE = "wallet_mod_ecommerce";
export const TYPE_WALLET_MOD_HOTEL = "wallet_mod_hotel";
export const TYPE_WALLET_BOOKIZON = "wallet_bookizon";